


import author from '@/components/author.vue';
export default {
    components: { author },
    name: 'index',
    data() {
        return {
            asyncSource: [],
            loading: false,

        };
    },
    mounted() {
        this.getAuthor()
    },
    methods: {
        async getAuthor() {
            //获取作者榜数据
            this.loading = true
            let res = await this.$global.authorIndex()
            res.code == 200 ? this.asyncSource = res.data.userList.data : []
            this.loading = false
        },


    }

}


